module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('h3', {
    staticClass: "sub-header"
  }, [_vm._v("Scheduled Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.schedules), function(item) {
    return _c('tr', [_c('td', [_vm._v("[" + _vm._s(item.channel) + "] " + _vm._s(item.text))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(item.scheduled_at))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-3",
      staticStyle: {
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(item.condition))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(item.operator))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeMsg(item)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-trash"
    })])])])
  }), 0)])]), _vm._v(" "), _c('h3', {
    staticClass: "sub-header"
  }, [_vm._v("Recent Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.recents), function(item) {
    return _c('tr', [_c('td', [_vm._v("[" + _vm._s(item.channel) + "] " + _vm._s(item.text))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(item.send_at))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-3",
      staticStyle: {
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(item.condition))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(item.operator))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Scheduled Date")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Condition")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Sender")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Text")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Date Sent")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Condition")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Sender")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37ba1f30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard.vue
// module id = 36
// module chunks = 1